<template>
  <div class="clearfix main_center">
    <div class="right-content clearfix busWinessRight">
      <el-card class="box-card" style="margin-bottom: 10px">
        <div slot="header" class="clearfix">
          <span>基本信息</span>
        </div>
        <el-form label-width="200px">
          <el-row>
            <el-col v-for="(item, ind) of basicList" :key="ind" :span="item.span || 12">
              <el-form-item :label="item.label">
                <span>{{ detail[item.dataIndex] }} {{ item.unit }}</span>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-card>

      <el-card class="box-card" style="margin-bottom: 10px">
        <div slot="header" class="clearfix">
          <span>定标委员会小组</span>
        </div>
        <el-table :data="detail.committeeList" stripe border style="width: 100%">
          <el-table-column type="index" header-align="center" align="center" label="序号" width="80"> </el-table-column>
          <el-table-column prop="name" align="left" :show-overflow-tooltip="true" min-width="150" label="姓名">
            <template slot-scope="scope">
              <span>{{ dealAesDecrypt(scope.row.name) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="code" align="left" :show-overflow-tooltip="true" min-width="200" label="身份证号码">
            <template slot-scope="scope">
              <span>{{ dealAesDecrypt(scope.row.code) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="workUnit" align="center" width="150" label="工作单位"></el-table-column>
          <el-table-column prop="work" align="center" width="150" label="在定标中承担的工作">
            <template slot-scope="scope">
              <span :style="{ color: scope.row.work == '1' ? '#F5222D' : '' }">{{ scope.row.work == 1 ? '组长' : '成员' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="linkphone" align="center" width="150" label="联系方式">
            <template slot-scope="scope">
              <span>{{ dealAesDecrypt(scope.row.linkphone) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="authStatus" align="center" width="150" label="专家签章授权状态" :render-header="renderHeader">
            <template slot-scope="scope" v-if="scope.row.authStatus">
              <el-tag v-if="scope.row.authStatus == 1" :type="scope.row.authStatus == 1 ? 'success' : 'danger'">
                {{ scope.row.authStatus == 1 ? "有效" : "" }}
              </el-tag>
            </template>
          </el-table-column>
        </el-table>
      </el-card>

      <el-card class="box-card" style="margin-bottom: 10px">
        <div slot="header" class="clearfix">
          <span>定标监督小组</span>
        </div>
        <el-table :data="detail.superviseList" stripe border style="width: 100%">
          <el-table-column type="index" header-align="center" align="center" label="序号" width="80"> </el-table-column>
          <el-table-column prop="name" align="left" :show-overflow-tooltip="true" min-width="150" label="姓名">
            <template slot-scope="scope">
              <span>{{ dealAesDecrypt(scope.row.name) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="code" align="left" :show-overflow-tooltip="true" min-width="200" label="身份证号码">
            <template slot-scope="scope">
              <span>{{ dealAesDecrypt(scope.row.code) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="workUnit" align="center" width="150" label="工作单位"></el-table-column>
          <el-table-column prop="work" align="center" width="150" label="在定标中承担的工作">
            <template slot-scope="scope">
              <span :style="{ color: scope.row.work == '1' ? '#F5222D' : '' }">{{ scope.row.work == 1 ? '组长' : '成员' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="linkphone" align="center" width="150" label="联系方式">
            <template slot-scope="scope">
              <span>{{ dealAesDecrypt(scope.row.linkphone) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="authStatus" align="center" width="150" label="专家签章授权状态" :render-header="renderHeader">
            <template slot-scope="scope" v-if="scope.row.authStatus">
              <el-tag v-if="scope.row.authStatus == 1" :type="scope.row.authStatus == 1 ? 'success' : 'danger'">
                {{ scope.row.authStatus == 1 ? "有效" : "" }}
              </el-tag>
            </template>
          </el-table-column>
        </el-table>
      </el-card>
    </div>

    <div class="left-content busWinessLeft">
      <div class="left-navbar">
        <div class="pageInfo">
          <p class="title">系统标识码</p>
          <p>
            交易系统标识码<br />
            <span>{{ platformCode }}</span>
          </p>
          <p>
            公共服务平台标识码<br />
            <span>{{ pubServicePlatCode }}</span>
          </p>
        </div>
        <div class="left-navbar">
          <el-button @click="goBack()" size="small">返回</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { aesDecrypt } from "@/utils";
import { tabsCloseCurrentHandle } from "@/utils/routeTab";
export default {
  name: "ScalingExpertInfo_detail",
  components: {},
  data() {
    return {
      auditForm: {
        mark: "",
        isPass: false,
      },
      dialogVisible: false,
      detail: {
        committeeList: [],
        superviseList: [],
      },
      platformCode: "",
      pubServicePlatCode: "",
      filingCBtn: false,
      backCBtn: false,
      auditHisTable: [],
      // 专家查看权限状态：0，01待申请02待授权03已授权04已拒绝
      expertStatus: "0",
      // 项目是否抽取完成
      projectIsFinish: "1",
      isExpert: false,
      id: "",
      applyInfo: {},
      printData: {
        noCode: "",
      },
      entityId: "",
      refreshLoading: false,
      attachmentList: [],
      basicList: [
        { label: "所属招标项目：", dataIndex: "tenderProjectName", span: 24 },
        { label: "所属招标项目编号：", dataIndex: "tradePlatfTenderProjectCode" },
        { label: "评标类型：", dataIndex: "dbwyh" },
        { label: "定标时间：", dataIndex: "decisionStartTime" },
        { label: "计划定标时长：", dataIndex: "decisionPlanTime", unit: "小时" },
        { label: "报到时间：", dataIndex: "partTime" },
        { label: "定标地点：", dataIndex: "decisionAddress" },
        { label: "备注：", dataIndex: "remark", span: 24 },
      ],
    };
  },
  methods: {
    dealAesDecrypt(data) {
      return aesDecrypt(data, 'aesuserkey202311')
    },
    getDetail() {
      this.$http.get(`/decisioncommitteebuild/get?id=${this.id}`).then((res) => {
        const { code, data } = res.data;
        if (code == 1) {
          data.dbwyh = '定标委员会';
          this.detail = data;
          this.entityId = data.tradeId;
        }
      });
    },

    refreshAuthStatus() {
      this.$http.get(`/decisioncommitteebuild/refreshStateBXT?entityId=${this.id}`).then((res) => {
        if (res.data.code == "1") {
          this.$message.success(res.data.msg);
          this.getDetail();
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },

    renderHeader(h, { column }) {
      return h("span", [
        column.label,
        h("i", {
          class: "el-icon-refresh",
          style: "cursor: pointer;",
          on: {
            click: () => {
              this.refreshAuthStatus();
            },
          },
        }),
      ]);
    },

    goBack() {
      tabsCloseCurrentHandle();
      this.$router.push({
        // name: "scalingExpertInfo",
        path: `/expert_extract/scalingExpertInfo`,
      });
    },
  },
  created() {
    this.id = this.$route.query.id;
    this.getDetail();
  },
};
</script>
<style lang="less" scoped>
.el-form /deep/ .el-form-item.double-row {
  width: 50%;
}
.el-form /deep/ .el-form-item {
  margin-bottom: 0;
}
.right-content.busWinessRight {
  width: calc(100% - 160px);
}

.left-content.busWinessLeft {
  .left-navbar {
    width: 150px;
    border: none;
  }
}
</style>
